
import * as defaultImport from "@splunk/react-docs/DockingTabBar";
export * from "@splunk/react-docs/DockingTabBar";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
